import { Controller } from '@hotwired/stimulus'
import {
  trans, ACCOUNT_PROMPT, NUMBER_PROMPT, KEYWORD_PROMPT, TWILIO_BUSINESS_NAME_PROMPT, TWILIO_ACCOUNT_PROMPT, TWILIO_TOKEN_PROMPT
} from '../../translator'

export default class extends Controller {
  static values = {
    type: String
  }

  formValidation () {
    return {
      fields: {
        sms_route_account: {
          identifier: 'sms_route_account',
          rules: [{
            type: 'empty',
            prompt: trans(ACCOUNT_PROMPT, {}, 'sms')
          }]
        },
        sms_route_twilio_business_display_name: {
          identifier: 'sms_route_twilioBusinessDisplayName',
          rules: [{
            type: 'empty',
            prompt: trans(TWILIO_BUSINESS_NAME_PROMPT, {}, 'sms')
          }]
        },
        sms_route_twilio_account_sid: {
          identifier: 'sms_route_twilioAccountSid',
          rules: [{
            type: 'empty',
            prompt: trans(TWILIO_ACCOUNT_PROMPT, {}, 'sms')
          }]
        },
        sms_route_twilio_auth_token: {
          identifier: 'sms_route_twilioAuthToken',
          rules: [{
            type: 'empty',
            prompt: trans(TWILIO_TOKEN_PROMPT, {}, 'sms')
          }]
        },
        ...(this.typeValue === 'keyword'
          ? {
              sms_route_keyword: {
                identifier: 'sms_route_keyword',
                rules: [{
                  type: 'empty',
                  prompt: trans(KEYWORD_PROMPT, {}, 'sms')
                }]
              }
            }
          : {
              sms_route_number: {
                identifier: 'sms_route_number',
                rules: [{
                  type: 'empty',
                  prompt: trans(NUMBER_PROMPT, {}, 'sms')
                }]
              }
            })
      },
      inline: true
    }
  }

  connect () {
    $('form').form(this.formValidation())

    $('#sms_route_type').dropdown({
      onChange: (value) => {
        this.typeValue = value
        $('form').form(this.formValidation())

        if (value === 'keyword') {
          this.showKeywordInput()
        } else {
          this.showNumberInput()
        }
      }
    }
    )
  }

  showKeywordInput () {
    $('#keyword').removeClass('d-none')
    $('#number').addClass('d-none')
  }

  showNumberInput () {
    $('#keyword').addClass('d-none')
    $('#number').removeClass('d-none')
  }

  submit () {
    if ($('form').form('is valid')) {
      if (this.typeValue === 'keyword') {
        $('#sms_route_number').val('')
      } else {
        $('#sms_route_keyword').val('')
      }

      $('form').submit()
    }

    $('form').form('validate form')
  }
}
